import ExamEdit from "@/controllers/exam/exam-edit.js";
import CONFIG from "@/assets/js/config.custom.js";
import { required, maxLength } from "vuelidate/lib/validators";
import axios from "axios";
import store from "@/store";

export default {
  extends: ExamEdit,

  data() {
    return {
      examTypeArr: CONFIG.EXAM_TYPE,
      exam_type: "",
      acdYearArr: [],
      termArr: [],
      academicYearName: '',
      termName: '',
      examData: {
        acdYearId: '',
        termId: ''
      }
    };
  },
  
  computed: {
    getAcademicYearName() {
      if (this.academicYearName) {
        return this.academicYearName;
      }
      const found = this.acdYearArr.find(item => item.id == this.examData.acdYearId);
      return found ? found.text : '';
    },
  },

  validations: {
    exam_type: { required },
    exam_name: {
      required,
      maxLength: maxLength(100)
    },
    exam_start_date: { required },
    exam_end_date: { required },
    selectedSubjects: { required }
  },

  methods: {
    // Exclude Early Year classes from Exam class dropdown
    async getClass(yearId) {
      try {
        const response = await axios.get("class/classList/" + yearId, {
          params: {
            campus_id: store.state.user.campus_id,
            exclude_early_year: 1,
          }
        });

        if (response.data) {
          let defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];

          this.classArr = defaultSelectOption.concat(response.data);
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.log("Class List API Error", error);
        this.isLoading = false;
      }
    },

    getCurrentPeriodList() {
      axios
      .get('score-setting/parent-acd-year')
      .then((response) => {
        if (response.data) {
          const rawData = response.data.data;
          this.acdYearArr = rawData.map(item => ({
            id: item.id,
            text: item.period_name
          }));

          const activeId = response.data.active_acd_year_id;
          this.examData.acdYearId = activeId ?? this.acdYearArr?.[0]?.id ?? null;
        }
      })
      .catch(this.logout);
    },

    async getExamDetail() {
      await ExamEdit.methods.getExamDetail.call(this);

      if (this.gradingInfo && this.gradingInfo.exam_type) {
        this.exam_type = String(this.gradingInfo.exam_type);
      }

      if (this.gradingInfo && this.gradingInfo.term_id) {
        this.examData.acdYearId = this.gradingInfo.academic_year;
        
        const acdYear = this.acdYearArr.find(item => item.id == this.gradingInfo.academic_year);
        this.academicYearName = acdYear ? acdYear.text : '';
      }
    },

    logout(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
    },

    confirmUpdate() {
      if (this.disabled) return;
      this.submitted = true;
      this.isLoading = true;
      this.fullMarkErrors = [];
      this.passMarkErrors = [];
      this.distinctionMarkErrors = [];

      if (this.exam_start_date && this.exam_end_date && new Date(this.exam_end_date) < new Date(this.exam_start_date)) {
        this.isError = true;
      } else {
        this.isError = false;
      }

      this.subjectArr
        .filter(s => this.selectedSubjects.includes(s.id))
        .forEach(subject => {
            if (subject.full_mark && (subject.full_mark > 100 || subject.full_mark <= 0)) {
              this.fullMarkErrors.push(subject.id);
            }

            if (subject.pass_mark && (subject.pass_mark > 100 || subject.pass_mark <= 0)) {
              this.passMarkErrors.push(subject.id);
            }

            if (subject.distinction_mark && (subject.distinction_mark > 100 || subject.distinction_mark <= 0)) {
              this.distinctionMarkErrors.push(subject.id);
            }
        });

      if (
        this.$v.$invalid
        || !this.selectedSubjects.length
        || this.fullMarkErrors.length 
        || this.passMarkErrors.length 
        || this.distinctionMarkErrors.length
      ) {
        this.isLoading = false;
        this.validationErrors = {};
        return;
      }

      this.clearValidationErrors();
      this.update();
    },

    update() {
      const subjectsData = this.subjectArr
        .filter(subject => this.selectedSubjects.includes(subject.id))
        .map(subject => ({
          id: subject.id,
          full_mark: subject.full_mark,
          pass_mark: subject.pass_mark,
          distinction_mark: subject.distinction_mark
        }));
      const request = {
        academic_year: this.examData.acdYearId,
        class_id: this.class_id,
        campus_id: this.$store.state.user.campus_id,
        campus_grade_id: this.gradingInfo.campus_grade_id,
        created_id: this.$store.state.user.id,
        exam_name: this.exam_name,
        exam_id: this.$route.params.exam_id,
        exam_start_date: this.exam_start_date,
        exam_end_date: this.exam_end_date,
        exam_type: this.exam_type,
        term_id: this.gradingInfo.term_id,
        subjects: subjectsData,
      };

      axios.post("/exam/update", request, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.status == 200) {
          this.$notification.success("Exam Updated Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: "examList" });
        }
      })
      .catch(error => {
        this.printValidationError(error.response);
        this.isLoading = false;
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getCurrentPeriodList();
  }
};
